export default __webpack_public_path__ + "09928f1787ee03a21f42fd7cc8db5b65.webp";